import AttendeeAction from './attendeeAction';
import Attendee from '../../../models/attendeeModel';
import DeleteRefundRequestPostAction from '../../order/post-action/deleteRefundRequestPostAction';

export default class DeleteRefundRequestAction extends AttendeeAction {
    static NAME = 'delete_refund_requests';
    static POST_ACTION_COMPONENT = DeleteRefundRequestPostAction;

    static condition(attendee) {
        if (!attendee.refund_requests?.length || !attendee.refund_requests.filter(rr => rr.removed === null).length) {
            return false;
        }

        return true;
    }

    static is_disabled({ items }) {
        return items.length !== 1 || !items.some(i => this.condition(i));
    }

    static is_attendee_valid({ attendee, order }) {
        return !attendee.removed;
    }

    static is_available({ mode }) {
        return mode === 'detail';
    }

    get needs_confirm() {
        return false;
    }

    get needs_selection() {
        return false;
    }

    get post_action() {
        return true;
    }

    runPostAction({ requests_to_delete }) {
        return Attendee.perform_action(this.constructor.NAME, requests_to_delete, { organization: this.organization, event: this.event });
    }

    get is_direct() {
        return true;
    }

    run() {
        return Promise.resolve(true);
    }

    onActionDone() {
        if (!this.async) {
            this.sync();
        }
        this.onClose();
    }
}
